/**
 * Store Dossier
 */
export default {
    state: {
        provenances: [],
        publicite: null,
        interne: 83,
        internet: null,
        client: 71,
        evenement: null,
        valority: 15,
        simulateur: 72,
    },

    mutations: {
        /**
         * Initialise le state provenances
         */
        setProvenances: function (state, provenances) {
            state.provenances = provenances
        }
    },

    actions: {
        refreshProvenances: function ({ commit }) {
            return axios.get('/api/provenances?order=nom&direction=asc').then(response => {
                commit('setProvenances', response.data.data)
            })
        },
    },

    getters: {
        /**
         * Liste d'options de provenances
         */
        optionsProvenances: state => {
            let options = state.provenances.map(provenance => {
                return {label: provenance.nom, value: provenance.id}
            })

            options =  _.sortBy(options, 'label')
            options.unshift({label: 'Non renseigné', value: 'null'})

            return options
        },

        provenances: state => {
            return state.provenances
        },
    }
}
